module.exports = ":host .form-group {\n  display: flex;\n  align-items: center;\n}\n:host .form-group > div {\n  margin-right: 10px;\n}\n:host .form-group textarea {\n  max-width: 450px;\n  margin-top: 10px;\n}\n:host p {\n  margin-bottom: 15px;\n}\n:host .control-label {\n  text-align: right;\n  width: 160px;\n}\n:host .control-label label {\n  margin-bottom: 0;\n}\n:host .merchantIds {\n  margin-left: 12px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ops-support/covid-19/closure/covid-19-closure.component.less
// module id = 1034
// module chunks = 0